/**
 * PILLAR 1 — Project Trust Summary card.
 *
 * Lives on the project dashboard. One glance answers:
 * "Can my crew build from this plan set today?"
 *
 * Shows the overall verdict + category breakdown + the top three next
 * actions with deep-link buttons. No technical jargon escapes.
 */
import { useNavigate } from "react-router-dom";
import { TrustBar } from "./TrustBar";

const ACTION_ROUTE = {
  open_survey_control: (target) => `/projects/${target}/survey-control`,
  open_calibration: (target) => `/projects/${target}/calibration`,
  open_alignments: (target) => `/projects/${target}/survey-control`,
  open_revisions: (target) => `/projects/${target}/revisions`,
  open_upload: (target) => `/projects/${target}?upload=1`,
  open_intake: (target) => `/projects/${target}/intake`,
  open_sheet: (target) => `/sheet/${target}`,
  calibrate_sheet: (target) => `/sheet/${target}?mode=calibrate`,
  place_alignment: (target) => `/sheet/${target}?mode=alignment`,
  configure_storage: () => `/platform/admin?section=storage`,
};

export function ProjectTrustSummary({ projectId }) {
  const navigate = useNavigate();
  const handleAction = (action) => {
    const builder = ACTION_ROUTE[action?.type];
    if (!builder) return;
    const url = builder(action.target);
    if (url) navigate(url);
  };

  return (
    <div
      className="fop-surface-2 rounded-lg p-4 border border-[var(--fop-border)]"
      data-testid="project-trust-summary"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--fop-text-3)]">
          Plan set trust
        </div>
      </div>
      <TrustBar
        scope="project"
        projectId={projectId}
        onAction={handleAction}
        className="gap-2"
      />
    </div>
  );
}

export default ProjectTrustSummary;
